import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getApiClient } from 'api';
import { getUsersMessagesCounterparts, type MessagesCounterpartResponse } from 'api/generated';
import type { ProfileType } from 'types/user';

export const fetchConversations = createAsyncThunk<MessagesCounterpartResponse, ProfileType>(
  'users/messages-counterparts/fetchConversations',
  async (profile, { rejectWithValue }) => {
    try {
      const response = await getUsersMessagesCounterparts({
        client: getApiClient(false),
        query: profile,
        throwOnError: true,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const conversationsSlice = createSlice({
  name: 'conversations',
  initialState: {
    error: false,
    loading: false,
    conversations: [] as MessagesCounterpartResponse,
    conversationIndex: 0,
  },
  reducers: {
    setActiveConversation: (state, action: PayloadAction<number>) => {
      state.conversationIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchConversations.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(fetchConversations.fulfilled, (state, action: PayloadAction<MessagesCounterpartResponse>) => {
      state.loading = false;
      state.conversations = action.payload;
    });
    builder.addCase(fetchConversations.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export const { setActiveConversation } = conversationsSlice.actions;
export const conversationsReducer = conversationsSlice.reducer;
